// All supported job roles - Indian Market Variations - sorted alphabetically
const ALL_ROLES = [
  "3D CAD Modeler",
  "A/B Testing Analyst",
  "ABM Specialist",
  "Account Development Representative (ADR)",
  "Account Manager (CS)",
  "Account Manager (Post-Sales)",
  "Account Success Manager",
  "Account-Based Marketing Specialist",
  "ADAS Engineer",
  "Admin Business Partner",
  "Admin Support Specialist",
  "Admin Virtual Assistant",
  "Administrative Assistant (Remote)",
  "Administrative Clerk",
  "Administrative Coordinator",
  "Administrative Intern",
  "Administrative Operations Assistant",
  "Advanced Excel Executive",
  "Affiliate Manager",
  "Affiliate Marketing Manager",
  "Affiliate Marketing Specialist",
  "Agent Builder",
  "Agentic AI Engineer",
  "AI Agent Builder",
  "AI Agent Engineer",
  "AI Application Engineer",
  "AI Apprentice",
  "AI Associate",
  "AI Automation Engineer",
  "AI Content Engineer",
  "AI Developer",
  "AI Development Manager",
  "AI Engineering Analyst",
  "AI Engineering Manager",
  "AI Ethics Engineer",
  "AI Graduate Engineer",
  "AI Guardrails / Evals Specialist",
  "AI Integration Engineer",
  "AI Interaction Designer",
  "AI Intern",
  "AI Lab Assistant",
  "AI Platform Engineer",
  "AI Product Manager",
  "AI Program Manager",
  "AI Project Manager",
  "AI Prompt Developer",
  "AI Prompt Engineer",
  "AI Prompt Specialist",
  "AI Research Assistant",
  "AI Research Engineer",
  "AI Research Intern",
  "AI Safety Analyst",
  "AI Safety Engineer",
  "AI Software Engineer",
  "AI Solutions Architect",
  "AI Solutions Engineer",
  "AI Support Engineer",
  "AI Systems Engineer",
  "AI Team Lead",
  "AI Trainer",
  "AI Trainer (LLM)",
  "AI/ML Engineer",
  "AI/ML Trainee",
  "Amazon VA",
  "Amazon Virtual Assistant",
  "Analytics Analyst",
  "Analytics Associate",
  "Analytics Consultant",
  "Analytics Manager",
  "Android Application Developer",
  "Android Developer",
  "Angular Developer",
  "API Developer",
  "API Developer (Python)",
  "API Engineer",
  "API Support Engineer",
  "API Test Engineer",
  "API Tester",
  "Application Developer",
  "Application Engineer",
  "Applied Data Scientist",
  "Applied Machine Learning Engineer",
  "Applied ML Engineer",
  "Applied Scientist",
  "Applied Scientist (ML/AI)",
  "Appointment Setter",
  "AR/VR Developer",
  "Assistant to the CEO",
  "Assistant to the Director",
  "Assistant to the President",
  "Associate Data Analyst",
  "Associate Data Scientist",
  "Associate Project Manager",
  "Associate Software Developer",
  "AutoCAD Engineer",
  "Automation Developer",
  "Automation Engineer",
  "Automation Lead",
  "Automation QA Analyst",
  "Automation QA Engineer",
  "Automation QA Specialist",
  "Automation Test Architect",
  "Automation Test Engineer",
  "Automation Test Manager",
  "Automation Tester",
  "Automation Testing Engineer",
  "Automotive Design Engineer",
  "Automotive Embedded Engineer",
  "Automotive Embedded Software Engineer",
  "Automotive Engineering Intern",
  "Automotive Software Engineer",
  "AUTOSAR Engineer",
  "AWS Cloud Engineer",
  "AWS DevOps Engineer",
  "AWS Solutions Architect",
  "Azure Cloud Engineer",
  "Azure DevOps Engineer",
  "Back Office Associate",
  "Back Office Executive",
  "Back-End Developer",
  "Back-End Engineer",
  "Backend Architect",
  "Backend Developer",
  "Backend Developer (Node.js)",
  "Backend Developer (Python)",
  "Backend Engineer",
  "Backend Engineering Manager",
  "Backend Executive",
  "Backend Process Executive",
  "Battery Cell Engineer",
  "Battery Controls Engineer",
  "Battery Engineer",
  "Battery Engineering Manager",
  "Battery Management System (BMS) Engineer",
  "Battery Management System Engineer",
  "Battery Pack Engineer",
  "Battery Systems Engineer",
  "Battery Test Engineer",
  "Battery Validation Engineer",
  "BDA (Business Development Associate)",
  "BDE",
  "BDE (US Shift)",
  "BDM (US Shift)",
  "BDR",
  "BDR (Business Development Representative)",
  "BDR Intern",
  "BDR Manager",
  "BI Analyst",
  "BI Developer",
  "BI Manager",
  "Big Data Engineer",
  "Blog Manager",
  "BMS Architect",
  "BMS Calibration Engineer",
  "BMS Engineer",
  "BMS Hardware Engineer",
  "BMS Software Engineer",
  "Body Design Engineer",
  "Bookkeeping VA",
  "BPO Executive (Voice/Non-Voice)",
  "Brand Manager",
  "Brand Marketing Manager",
  "Brand Strategist",
  "BSP Engineer",
  "Build and Release Engineer",
  "Business Analyst",
  "Business Analyst (Data)",
  "Business Data Analyst",
  "Business Development Associate",
  "Business Development Associate (BDA)",
  "Business Development Executive",
  "Business Development Executive (International Voice Process)",
  "Business Development Executive (Night Shift)",
  "Business Development Executive (UK Shift)",
  "Business Development Executive (US Shift)",
  "Business Development Intern",
  "Business Development Lead",
  "Business Development Manager",
  "Business Development Manager (US Shift)",
  "Business Development Representative",
  "Business Development Representative (BDR)",
  "Business Development Specialist",
  "Business Intelligence Analyst",
  "Business Intelligence Manager",
  "Business Operations Analyst",
  "Business Operations Associate",
  "Business Operations Manager",
  "Business Operations Specialist",
  "Business Support Specialist",
  "C-Suite Executive Assistant",
  "CAD Designer",
  "CAD Drafter",
  "CAD Draftsman",
  "CAD Engineer",
  "CAD Intern",
  "CAD Specialist",
  "CAD Trainee",
  "Calendar Manager (Virtual)",
  "Campaign Manager",
  "Carbon Accountant Specialist",
  "Carbon Accounting Analyst",
  "Carbon Analyst",
  "Carbon Footprint Analyst",
  "Carbon Manager",
  "Category Growth Manager",
  "CATIA Designer",
  "Chargeback Analyst",
  "Charging Infrastructure Engineer",
  "Charging Systems Engineer",
  "Chassis Engineer",
  "Chat Agent",
  "Chat Support Associate",
  "Chat Support Executive",
  "Chatbot Designer",
  "Chief AI Officer",
  "Chief AI Officer (CAIO)",
  "Chief Analytics Officer (CAO)",
  "Chief Artificial Intelligence Officer",
  "Chief Brand Officer",
  "Chief Business Development Officer",
  "Chief Client Officer",
  "Chief Communications Officer",
  "Chief Customer Officer",
  "Chief Customer Officer (CCO)",
  "Chief Customer Service Officer",
  "Chief Data & AI Officer",
  "Chief Data & Analytics Officer (CDAO)",
  "Chief Data Officer",
  "Chief Data Officer (CDO)",
  "Chief Data Scientist",
  "Chief Digital Officer",
  "Chief Engineer",
  "Chief Engineering Officer",
  "Chief Environmental Officer",
  "Chief ESG Officer",
  "Chief Experience Officer (CXO)",
  "Chief Green Officer",
  "Chief Growth Officer (CGO)",
  "Chief Information Officer (Data-focused)",
  "Chief Machine Learning Officer",
  "Chief Marketing Officer (CMO)",
  "Chief Operating Officer (COO)",
  "Chief Quality Officer (CQO)",
  "Chief Revenue Officer",
  "Chief Revenue Officer (CRO)",
  "Chief Software Architect",
  "Chief Sustainability Officer",
  "Chief Sustainability Officer (CSO)",
  "Chief Technology Officer (AI-focused)",
  "Chief Technology Officer (CTO)",
  "Circular Economy Specialist",
  "Clean Energy Engineer",
  "Client Account Manager",
  "Client Outcomes Manager",
  "Client Relationship Manager",
  "Client Services Associate",
  "Client Success Manager",
  "Client Support Specialist",
  "Climate Analyst",
  "Climate Analyst Intern",
  "Climate Change Analyst",
  "Climate Risk Analyst",
  "Clinical Data Manager",
  "Cloud Architect",
  "Cloud DevOps Engineer",
  "Cloud Engineer",
  "Cloud Infrastructure Engineer",
  "Cloud Security Engineer",
  "Cloud Solutions Architect",
  "CMO",
  "Community Manager",
  "Compliance Data Analyst",
  "Computer Operator",
  "Computer Vision Data Scientist",
  "Computer Vision Engineer",
  "Contact Center Representative",
  "Content Creator",
  "Content Distribution Manager",
  "Content Executive",
  "Content Growth Strategist",
  "Content Lead",
  "Content Manager",
  "Content Marketing Executive",
  "Content Marketing Intern",
  "Content Marketing Manager",
  "Content Marketing Specialist",
  "Content SEO Specialist",
  "Content SEO Strategist",
  "Content Strategist",
  "Content Writer",
  "Controls Engineer",
  "Controls Software Engineer",
  "Conversation Designer",
  "Conversational AI Designer",
  "Conversational AI Engineer",
  "Conversion Rate Optimization Specialist",
  "COO",
  "Copywriter",
  "Crash Safety Engineer",
  "Creator Partnerships Manager",
  "Credit Analyst",
  "Credit Risk Analyst",
  "Creo Design Engineer",
  "CRM Analyst",
  "CRM Executive",
  "CRM Marketing Specialist",
  "CRM Specialist",
  "CRO Specialist",
  "CS Ops Manager",
  "CS Team Manager",
  "CSM",
  "CTO",
  "CTO (EV/Auto)",
  "CTO - AI",
  "Customer Acquisition Specialist",
  "Customer Advocate",
  "Customer Advocate (Entry)",
  "Customer Care Executive (CCE)",
  "Customer Care Representative",
  "Customer Data Analyst",
  "Customer Education Specialist",
  "Customer Experience Manager",
  "Customer Health Analyst",
  "Customer Marketing Manager",
  "Customer Onboarding Manager",
  "Customer Onboarding Specialist (Entry)",
  "Customer Operations Specialist",
  "Customer Relationship Manager",
  "Customer Retention Specialist",
  "Customer Service Associate",
  "Customer Service Representative",
  "Customer Success Analyst",
  "Customer Success Associate",
  "Customer Success Coordinator",
  "Customer Success Director",
  "Customer Success Engineer",
  "Customer Success Executive",
  "Customer Success Intern",
  "Customer Success Manager",
  "Customer Success Manager (CSM)",
  "Customer Success Manager (Team)",
  "Customer Success Operations Manager",
  "Customer Success Specialist",
  "Customer Success Team Lead",
  "Customer Support Associate",
  "Customer Support Representative",
  "Customer Support VA",
  "Customer Trainer",
  "CX Manager",
  "Cybersecurity Analyst",
  "Cybersecurity Engineer",
  "Cypress Automation Engineer",
  "D2C Brand Manager",
  "Dashboard Analyst",
  "Data Analyst",
  "Data Analyst Associate",
  "Data Analyst I",
  "Data Analyst II",
  "Data Analyst III",
  "Data Analyst Intern",
  "Data Analytics Intern",
  "Data Analytics Manager",
  "Data Analytics Specialist",
  "Data Annotation Specialist",
  "Data Assistant",
  "Data Coordinator",
  "Data Engineer",
  "Data Engineer (Python)",
  "Data Entry Analyst",
  "Data Entry Associate",
  "Data Entry Clerk",
  "Data Entry Executive",
  "Data Entry Operations Executive",
  "Data Entry Operator",
  "Data Entry Operator (DEO)",
  "Data Entry Specialist",
  "Data Entry Virtual Assistant",
  "Data Executive",
  "Data Governance Analyst",
  "Data Governance Manager",
  "Data Intern",
  "Data Manager",
  "Data Mining Analyst",
  "Data Mining Expert",
  "Data Mining Specialist",
  "Data Modeler",
  "Data Operation Executive",
  "Data Operations Analyst",
  "Data Operations Manager",
  "Data Processing Clerk",
  "Data Processing Executive",
  "Data Quality Analyst",
  "Data Quality Analyst (Entry)",
  "Data Quality Manager",
  "Data Science Analyst",
  "Data Science Associate",
  "Data Science Director",
  "Data Science Fellow",
  "Data Science Intern",
  "Data Science Lead",
  "Data Science Manager",
  "Data Science Trainee",
  "Data Scientist",
  "Data Scientist (Entry Level)",
  "Data Scientist - Analytics",
  "Data Scientist - Deep Learning",
  "Data Scientist - ML",
  "Data Scientist - NLP",
  "Data Scientist I",
  "Data Scientist II",
  "Data Specialist",
  "Data Technician",
  "Data Visualization Analyst",
  "Database Administrator",
  "Database Administrator (DBA)",
  "Database Analyst",
  "Database Developer (NoSQL)",
  "Decarbonization Specialist",
  "Decision Scientist",
  "Deep Learning Engineer",
  "Delivery Coordinator",
  "Demand Generation Manager",
  "Demand Generation Specialist",
  "Design Engineer (Mechanical)",
  "Design Engineering Intern",
  "Design Engineering Manager",
  "Desktop Support Engineer",
  "Developer Advocate",
  "Development Manager",
  "DevOps Architect",
  "DevOps Consultant",
  "DevOps Engineer",
  "DevOps Engineer (AWS)",
  "DevOps Engineer (Azure)",
  "DevOps Intern",
  "DevOps Lead",
  "DevOps Manager",
  "DevOps Specialist",
  "DevSecOps Engineer",
  "Digital Analytics Analyst",
  "Digital Analytics Specialist",
  "Digital Copywriter",
  "Digital Marketer",
  "Digital Marketing Analyst",
  "Digital Marketing Assistant",
  "Digital Marketing Associate",
  "Digital Marketing Coordinator",
  "Digital Marketing Director",
  "Digital Marketing Executive",
  "Digital Marketing Intern",
  "Digital Marketing Manager",
  "Digital Marketing Specialist",
  "Digital Marketing Strategist",
  "Digital Media Buyer",
  "Diploma Engineer Trainee (DET)",
  "Director - AI Strategy",
  "Director - AI/ML",
  "Director - Automation Strategy",
  "Director - Data Science",
  "Director - Digital Marketing",
  "Director - Operations",
  "Director - PMO",
  "Director - QA",
  "Director - Sales",
  "Director - Sustainability",
  "Director of Administrative Services",
  "Director of AI",
  "Director of AI Engineering",
  "Director of AI Research",
  "Director of Analytics",
  "Director of Applied AI",
  "Director of Applied Data Science",
  "Director of Backend Engineering",
  "Director of Battery Engineering",
  "Director of BI",
  "Director of Brand",
  "Director of Business Development",
  "Director of Business Intelligence",
  "Director of Business Operations",
  "Director of Client Services",
  "Director of Client Success",
  "Director of Communications",
  "Director of Computer Vision",
  "Director of Content",
  "Director of Content Marketing",
  "Director of Customer Experience",
  "Director of Customer Onboarding",
  "Director of Customer Success",
  "Director of Data",
  "Director of Data & Analytics",
  "Director of Data Analytics",
  "Director of Data Operations",
  "Director of Data Science",
  "Director of Data Science & ML",
  "Director of Demand Generation",
  "Director of Ecommerce Marketing",
  "Director of Embedded Systems",
  "Director of Energy Management",
  "Director of Engineering",
  "Director of Environmental Affairs",
  "Director of ESG",
  "Director of EV Engineering",
  "Director of Executive Support",
  "Director of Frontend Engineering",
  "Director of Growth",
  "Director of Growth Marketing",
  "Director of Implementation",
  "Director of Insights",
  "Director of Machine Learning",
  "Director of Marketing",
  "Director of Marketing Analytics",
  "Director of Marketing Operations",
  "Director of Mechanical Design",
  "Director of ML",
  "Director of ML Engineering",
  "Director of ML Operations",
  "Director of NLP",
  "Director of Operations",
  "Director of Paid Media",
  "Director of Performance Marketing",
  "Director of Powertrain",
  "Director of Product Marketing",
  "Director of Professional Services",
  "Director of Project Management",
  "Director of Prompt Engineering",
  "Director of Python Development",
  "Director of QA",
  "Director of QA Automation",
  "Director of Quality Assurance",
  "Director of Quality Engineering",
  "Director of Renewable Energy",
  "Director of Research",
  "Director of Research & Data Science",
  "Director of Sales",
  "Director of Sales Development",
  "Director of SEO",
  "Director of Social Media",
  "Director of Software Engineering",
  "Director of Solar Operations",
  "Director of Sustainability",
  "Director of Test Engineering",
  "Director of Testing",
  "Director of Vehicle Engineering",
  "Director of Virtual Assistance",
  "Director of Virtual Operations",
  "Director of Virtual Project Management",
  "Director of Web Development",
  "Display Advertising Specialist",
  "Distinguished Data Scientist",
  "Django Developer",
  "Documentation Executive",
  "Dot Net Developer",
  "Drivetrain Engineer (EV)",
  "Drone Pilot",
  "Durability Engineer",
  "E-commerce Assistant",
  "e-Drive Engineer",
  "EA to CEO",
  "EA to COO",
  "EA to Founder",
  "Ecommerce Digital Strategist",
  "Ecommerce Marketing Manager",
  "Ecommerce Marketing Specialist",
  "Ecommerce Virtual Assistant",
  "ECU Software Engineer",
  "Editorial Manager",
  "Editorial Strategist",
  "Electric Drive Engineer",
  "Electric Motor Engineer",
  "Electric Powertrain Engineer",
  "Electric Vehicle Design Engineer",
  "Electric Vehicle Engineer",
  "Email Marketer",
  "Email Marketing Executive",
  "Email Marketing Intern",
  "Email Marketing Manager",
  "Email Marketing Specialist",
  "Embedded Firmware Engineer",
  "Embedded Linux Engineer",
  "Embedded Software Engineer",
  "Embedded Software Engineer (Auto)",
  "Embedded Systems Architect",
  "Embedded Systems Engineer",
  "Embedded Systems Engineer (Auto)",
  "Energy Analyst",
  "Energy Auditor",
  "Energy Efficiency Specialist",
  "Energy Manager",
  "Energy Storage Engineer",
  "Engineering Manager",
  "Engineering Manager (Python)",
  "Enterprise Customer Success Manager",
  "Entry-Level AI Developer",
  "Entry-Level Data Scientist",
  "Entry-Level Full Stack Developer",
  "Entry-Level Python Developer",
  "Entry-Level QA Engineer",
  "Environmental Analyst",
  "Environmental Analyst (Entry)",
  "Environmental Consultant",
  "Environmental Engineer",
  "Environmental Manager",
  "Environmental Specialist",
  "ESG Analyst",
  "ESG Analyst Intern",
  "ESG Consultant",
  "ESG Data Analyst",
  "ESG Manager",
  "ESG Reporting Analyst",
  "ESG Specialist",
  "ETL Developer (Python)",
  "EV Architect",
  "EV Battery Test Engineer",
  "EV Charging Engineer",
  "EV Design Engineer",
  "EV Engineer",
  "EV Engineering Intern",
  "EV Engineering Manager",
  "EV Powertrain Engineer",
  "EV Software Engineer",
  "EV Systems Engineer",
  "EV Test Engineer",
  "EV Trainee Engineer",
  "EV Validation Engineer",
  "EVP of AI & Innovation",
  "EVSE Engineer",
  "Executive Administrative Assistant",
  "Executive Assistant",
  "Executive Assistant (Remote)",
  "Executive Assistant Intern",
  "Executive Assistant Manager",
  "Executive Business Partner",
  "Executive Coordinator",
  "Executive Secretary",
  "Executive Virtual Assistant",
  "Experimentation Analyst",
  "Express.js Developer",
  "Exterior Design Engineer",
  "Facebook Ads Specialist",
  "FastAPI Developer",
  "Financial Analyst",
  "Financial Data Analyst",
  "Firmware Engineer",
  "Firmware Test Engineer",
  "Flask Developer",
  "Flutter Developer",
  "Foundation Model Engineer",
  "Founder's Office (EA)",
  "Fraud Analyst",
  "Fraud Risk Analyst",
  "Front-End Developer",
  "Front-End Engineer",
  "Frontend Architect",
  "Frontend Developer",
  "Frontend Engineer",
  "Frontend Engineering Manager",
  "Full Stack AI Developer",
  "Full Stack Architect",
  "Full Stack Cloud Developer",
  "Full Stack Developer",
  "Full Stack Developer I",
  "Full Stack Engineer",
  "Full Stack Engineering Manager",
  "Full Stack Intern",
  "Full Stack JavaScript Developer",
  "Full Stack Software Developer",
  "Full Stack Software Engineer",
  "Full Stack Tech Lead",
  "Full Stack Web Developer",
  "Functional Safety Engineer",
  "Game Developer (Unity)",
  "GenAI Developer",
  "GenAI Engineer",
  "GenAI Solutions Engineer",
  "Generative AI Engineer",
  "Generative AI Prompt Engineer",
  "GHG Accounting Analyst",
  "GIS Analyst",
  "Golang Developer",
  "Google Ads Specialist",
  "Graduate Engineer Trainee (GET)",
  "Graduate EV Engineer",
  "Graduate Software Developer",
  "Green Building Specialist",
  "Green Energy Intern",
  "Green Energy Specialist",
  "Growth Analyst (Product)",
  "Growth Content Strategist",
  "Growth Hacker",
  "Growth Marketer",
  "Growth Marketing Manager",
  "Growth Marketing Specialist",
  "Growth Product Manager",
  "Head - Battery Systems",
  "Head - Battery Technology",
  "Head - EV Engineering",
  "Head - Solar Projects",
  "Head of Administrative Services",
  "Head of AI",
  "Head of Analytics",
  "Head of Automation",
  "Head of Business Development",
  "Head of Business Intelligence",
  "Head of Business Operations",
  "Head of Client Services",
  "Head of Content",
  "Head of Customer Experience",
  "Head of Customer Success",
  "Head of Data",
  "Head of Data Analytics",
  "Head of Data Science",
  "Head of Digital Marketing",
  "Head of Engineering",
  "Head of Environmental",
  "Head of ESG",
  "Head of EV Engineering",
  "Head of Executive Support",
  "Head of Growth",
  "Head of Growth (Paid)",
  "Head of Machine Learning",
  "Head of Marketing",
  "Head of ML Engineering",
  "Head of Operations",
  "Head of Paid Media",
  "Head of Performance Marketing",
  "Head of Powertrain Engineering",
  "Head of Product Analytics",
  "Head of Product Engineering",
  "Head of Project Management",
  "Head of Prompt Engineering",
  "Head of Python Engineering",
  "Head of QA",
  "Head of Quality Assurance",
  "Head of Renewable Energy",
  "Head of SEO",
  "Head of Social",
  "Head of Social Media",
  "Head of Software Development",
  "Head of Sustainability",
  "Head of Test Engineering",
  "Head of Vehicle Design",
  "Head of Web Development",
  "Health Data Analyst",
  "Healthcare Data Analyst",
  "Healthcare Data Scientist",
  "Help Desk Specialist",
  "High Voltage Systems Engineer",
  "High-Voltage Systems Engineer",
  "HR Data Analyst",
  "HR Executive",
  "HV Systems Engineer",
  "Implementation Consultant",
  "Implementation Coordinator",
  "Implementation Engineer",
  "Implementation Manager",
  "Implementation Specialist",
  "Inbound Marketing Specialist",
  "Inbox Manager (Virtual)",
  "Influencer Manager",
  "Influencer Marketing Executive",
  "Influencer Marketing Manager",
  "Influencer Marketing Specialist",
  "Infrastructure Engineer",
  "Inside Sales Executive",
  "Inside Sales Representative",
  "Insights Analyst",
  "Insights Manager",
  "Integrated Marketing Manager",
  "Integration Engineer",
  "Integration Tester",
  "Intelligent Automation Engineer",
  "Interior Design Engineer (Auto)",
  "Internet Marketing Specialist",
  "Inverter Engineer",
  "iOS App Developer",
  "iOS Developer",
  "IT Recruiter",
  "Java Developer",
  "JavaScript Developer",
  "JavaScript Engineer",
  "JavaScript Full Stack Developer",
  "Jr. Data Scientist",
  "Junior Administrative Assistant",
  "Junior AI Developer",
  "Junior AI Engineer",
  "Junior Automation Tester",
  "Junior Automotive Engineer",
  "Junior Backend Developer",
  "Junior Battery Engineer",
  "Junior BDR",
  "Junior BI Analyst",
  "Junior Business Development Representative",
  "Junior Business Intelligence Analyst",
  "Junior Computer Vision Engineer",
  "Junior Data Analyst",
  "Junior Data Science Engineer",
  "Junior Data Scientist",
  "Junior DevOps Engineer",
  "Junior Embedded Systems Engineer",
  "Junior Environmental Analyst",
  "Junior EV Design Engineer",
  "Junior EV Engineer",
  "Junior Frontend Developer",
  "Junior Full Stack Developer",
  "Junior Machine Learning Engineer",
  "Junior Manual Tester",
  "Junior Mechanical Design Engineer",
  "Junior MERN Stack Developer",
  "Junior ML Engineer",
  "Junior NLP Engineer",
  "Junior Operations Associate",
  "Junior Powertrain Engineer",
  "Junior Project Coordinator",
  "Junior Project Manager",
  "Junior Prompt Engineer",
  "Junior Python Developer",
  "Junior Python Engineer",
  "Junior Python Programmer",
  "Junior QA Analyst",
  "Junior QA Automation Engineer",
  "Junior QA Engineer",
  "Junior QA Tester",
  "Junior SDET",
  "Junior SDR",
  "Junior SEO Executive",
  "Junior Software Developer",
  "Junior Software Engineer",
  "Junior Software Tester",
  "Junior Solar Engineer",
  "Junior Solar Project Engineer",
  "Junior Sustainability Analyst",
  "Junior Test Automation Engineer",
  "Junior Test Engineer",
  "Junior Validation Engineer",
  "Junior Vehicle Engineer",
  "Junior Virtual Assistant",
  "Junior Web Developer",
  "Kubernetes Administrator",
  "Kubernetes Engineer",
  "KYC Compliance Analyst",
  "Large Language Model Engineer",
  "Lead AI Engineer",
  "Lead Automation Engineer",
  "Lead Backend Developer",
  "Lead Battery Engineer",
  "Lead BI Analyst",
  "Lead BMS Engineer",
  "Lead Business Intelligence Analyst",
  "Lead Content Strategist",
  "Lead Customer Success Manager",
  "Lead Data Analyst",
  "Lead Data Scientist",
  "Lead Design Engineer",
  "Lead DevOps Engineer",
  "Lead Embedded Engineer",
  "Lead Embedded Systems Engineer",
  "Lead EV Engineer",
  "Lead EV Systems Engineer",
  "Lead Executive Assistant",
  "Lead Frontend Developer",
  "Lead Full Stack Developer",
  "Lead Full Stack Engineer",
  "Lead Growth Marketer",
  "Lead Machine Learning Engineer",
  "Lead Mechanical Design Engineer",
  "Lead ML Engineer",
  "Lead Operations Analyst",
  "Lead Performance Marketer",
  "Lead Powertrain Engineer",
  "Lead Product Analyst",
  "Lead Project Coordinator",
  "Lead Prompt Engineer",
  "Lead Python Developer",
  "Lead Python Engineer",
  "Lead QA Engineer",
  "Lead SDET",
  "Lead SEO Specialist",
  "Lead Software Engineer",
  "Lead Solar Engineer",
  "Lead Sustainability Analyst",
  "Lead Test Engineer",
  "Lead Web Developer",
  "LEED Consultant",
  "Legal Virtual Assistant",
  "Lending Operations Manager",
  "Lifecycle Marketing Manager",
  "Lifecycle Marketing Specialist",
  "Link Building Specialist",
  "Linux System Administrator",
  "Lithium-Ion Battery Engineer",
  "LLM Applications Engineer",
  "LLM Engineer",
  "LLM Evals Specialist",
  "LLM Prompt Engineer",
  "Load Test Engineer",
  "Local SEO Specialist",
  "Logistics Data Analyst",
  "Looker Analyst",
  "Machine Learning Analyst (Entry)",
  "Machine Learning Data Scientist",
  "Machine Learning Engineer",
  "Machine Learning Engineering Manager",
  "Machine Learning Intern",
  "Machine Learning Lead",
  "Machine Learning Scientist",
  "Machine Learning Trainee",
  "Manager - Battery/BMS",
  "Manager - Customer Success",
  "Manager - Product Analytics",
  "Manual QA Tester",
  "Manual Tester",
  "Market Development Representative (MDR)",
  "Market Research Analyst",
  "Marketing Analyst",
  "Marketing Analytics Manager",
  "Marketing Assistant",
  "Marketing Associate",
  "Marketing Automation Specialist",
  "Marketing Coordinator",
  "Marketing Data Analyst",
  "Marketing Data Scientist",
  "Marketing Director",
  "Marketing Intern",
  "Marketing Manager",
  "Marketing Operations Analyst",
  "Marketing Operations Executive",
  "Marketing Operations Manager",
  "Marketing Performance Analyst",
  "Marketing Trainee",
  "Marketplace Operations Manager",
  "MEAN Stack Developer",
  "MEAN/MERN Full Stack Developer",
  "MEAN/MERN Stack Developer",
  "Mechanical Design Engineer",
  "Mechanical Design Engineer (CAD)",
  "Mechanical Designer",
  "Mechanical Engineer",
  "Mechanical Engineering Manager",
  "Media Buyer",
  "Medical Coder",
  "Medical Virtual Assistant",
  "MERN Developer",
  "MERN Stack Developer",
  "MERN Stack Engineer",
  "MERN Stack Intern",
  "Meta Ads Specialist",
  "Microsoft Dynamics Consultant",
  "MIS Analyst",
  "MIS Executive",
  "MIS Executive (Management Information Systems)",
  "ML Architect",
  "ML Associate",
  "ML Development Manager",
  "ML Engineer",
  "ML Engineering Intern",
  "ML Engineering Manager",
  "ML Infrastructure Engineer",
  "ML Ops Engineer",
  "ML Platform Engineer",
  "ML Project Manager",
  "ML Research Engineer",
  "ML Software Engineer",
  "ML Team Lead",
  "ML Tech Lead",
  "MLOps Engineer",
  "Mobile QA Engineer",
  "Mobile Test Engineer",
  "MongoDB Developer",
  "Motor Design Engineer",
  "Natural Language Processing Engineer",
  "Net Zero Analyst",
  "Net Zero Specialist",
  "Network Engineer",
  "Next.js Developer",
  "NLP Data Scientist",
  "NLP Engineer",
  "NOC Engineer",
  "Node.js Developer",
  "Node.js Engineer",
  "NVH Engineer",
  "NX Design Engineer",
  "Off-Page SEO Specialist",
  "Office Administrator (Remote)",
  "Office Clerk (Remote)",
  "On-Page SEO Specialist",
  "Onboarding Specialist",
  "Online Assistant",
  "Online Marketing Executive",
  "Online Marketing Specialist",
  "Operations Analyst",
  "Operations Associate",
  "Operations Coordinator",
  "Operations Coordinator (Entry)",
  "Operations Data Analyst",
  "Operations Director",
  "Operations Executive",
  "Operations Intern",
  "Operations Manager",
  "Operations Specialist",
  "Operations Trainee",
  "Oracle EBS Consultant",
  "Organic Growth Specialist",
  "Outbound Marketing Specialist",
  "Outbound Sales Representative",
  "Paid Ads Specialist",
  "Paid Media Manager",
  "Paid Media Specialist",
  "Paid Search Specialist",
  "Paid Social Specialist",
  "Partnership Development Associate",
  "Payment Operations Analyst",
  "Penetration Tester",
  "People Analytics Analyst",
  "Performance Marketer",
  "Performance Marketing Analyst",
  "Performance Marketing Executive",
  "Performance Marketing Manager",
  "Performance Marketing Specialist",
  "Performance Test Engineer",
  "Performance Tester",
  "Personal Assistant",
  "Personal Assistant (PA)",
  "Personal Executive Assistant",
  "Personal Virtual Assistant",
  "PHP Developer",
  "Platform Engineer",
  "Playwright Test Engineer",
  "PMO Analyst",
  "PMO Coordinator",
  "PMO Manager",
  "Portfolio Manager",
  "Power BI Analyst",
  "Power BI Developer",
  "Power Electronics Engineer",
  "Power Platform Developer",
  "Powertrain Engineer",
  "Powertrain Engineering Manager",
  "PPC Analyst",
  "PPC Analyst (Pay Per Click)",
  "PPC Campaign Manager",
  "PPC Executive",
  "PPC Intern",
  "PPC Manager",
  "PPC Specialist",
  "Pre-Sales Engineer",
  "Presales Executive",
  "Pricing Analyst",
  "Principal AI Engineer",
  "Principal BMS Engineer",
  "Principal Customer Success Manager",
  "Principal Data Analyst",
  "Principal Data Scientist",
  "Principal DevOps Engineer",
  "Principal Embedded Engineer",
  "Principal EV Engineer",
  "Principal Executive Assistant",
  "Principal Full Stack Developer",
  "Principal Machine Learning Engineer",
  "Principal Mechanical Engineer",
  "Principal ML Engineer",
  "Principal Prompt Engineer",
  "Principal Python Developer",
  "Principal QA Engineer",
  "Principal SDET",
  "Principal Software Engineer",
  "Principal Sustainability Consultant",
  "Principal Test Engineer",
  "Process Analyst",
  "Process Associate",
  "Process Executive",
  "Process Improvement Specialist",
  "Product Analyst",
  "Product Analyst (Analytics)",
  "Product Analytics Analyst",
  "Product Data Analyst",
  "Product Data Scientist",
  "Product Design Engineer",
  "Product Design Engineer (Mechanical)",
  "Product Insights Analyst",
  "Product Marketing Manager",
  "Product Marketing Specialist",
  "Product Metrics Analyst",
  "Product Operations Manager",
  "Program Coordinator",
  "Program Manager",
  "Programmatic Specialist",
  "Programmer Analyst",
  "Project Administrator",
  "Project Analyst",
  "Project Assistant",
  "Project Associate",
  "Project Coordinator",
  "Project Coordinator (IT)",
  "Project Coordinator Intern",
  "Project Executive (PMO/Projects)",
  "Project Manager",
  "Project Specialist",
  "Prompt Analyst",
  "Prompt Architect",
  "Prompt Designer",
  "Prompt Engineer",
  "Prompt Engineer (LLM/GenAI)",
  "Prompt Engineer Intern",
  "Prompt Engineering Manager",
  "Prompt Engineering Specialist",
  "Prompt Specialist",
  "Prompt-Context Engineer",
  "PV Design Engineer",
  "Python API Developer",
  "Python Application Developer",
  "Python Architect",
  "Python Automation Developer",
  "Python Automation Engineer",
  "Python Backend Developer",
  "Python Data Developer",
  "Python Data Engineer",
  "Python Developer",
  "Python Developer Intern",
  "Python Development Manager",
  "Python Engineer",
  "Python Full Stack Developer",
  "Python Intern",
  "Python Programmer",
  "Python Scripting Developer",
  "Python Scripting Engineer",
  "Python Software Developer",
  "Python Software Engineer",
  "Python Team Lead",
  "Python Tech Lead",
  "Python Trainee",
  "Python Web Developer",
  "QA Analyst",
  "QA Analyst (Entry)",
  "QA Apprentice",
  "QA Architect",
  "QA Associate",
  "QA Automation Analyst",
  "QA Automation Engineer",
  "QA Automation Manager",
  "QA Automation Specialist",
  "QA Consultant",
  "QA Engineer",
  "QA Engineering Manager",
  "QA Executive (Quality Assurance)",
  "QA Intern",
  "QA Lead",
  "QA Manager",
  "QA Manual Tester",
  "QA Project Manager",
  "QA Specialist",
  "QA Team Lead",
  "QA Tester",
  "QA Tester (Entry)",
  "QA Trainee",
  "Quality Analyst",
  "Quality Architect",
  "Quality Assurance Engineer",
  "Quality Assurance Intern",
  "Quality Assurance Manager",
  "Quality Engineer",
  "Quantitative Analyst",
  "Quantitative Analyst (Data Science)",
  "Quantitative Data Scientist",
  "RAG Engineer",
  "React Developer",
  "React Engineer",
  "React Native Developer",
  "React.js Developer",
  "ReactJS Developer",
  "Real Estate Virtual Assistant",
  "Recommendation Systems Engineer",
  "Reconciliation Analyst",
  "Regression Tester",
  "Reinforcement Learning Engineer",
  "Relationship Manager",
  "Release Engineer",
  "Remote Administrative Assistant",
  "Remote Assistant",
  "Remote Executive Assistant",
  "Remote Operations Manager",
  "Remote Virtual Assistant",
  "Renewable Energy Engineer",
  "Renewable Energy Intern",
  "Renewable Energy Manager",
  "Renewal Manager",
  "Renewal Specialist",
  "Renewals Manager",
  "Renewals Specialist",
  "Reporting Analyst",
  "Reporting Analyst (Entry)",
  "Reporting Manager",
  "Reporting Specialist",
  "Research Analyst",
  "Research Analyst (Data)",
  "Research Data Assistant",
  "Research Data Scientist",
  "Research Engineer (ML)",
  "Research Scientist",
  "Responsible AI Engineer",
  "Retention Marketing Specialist",
  "Revenue Analyst",
  "Risk Analyst",
  "Robotics ML Engineer",
  "RPA Developer (UiPath)",
  "RTOS Engineer",
  "Sales Analyst",
  "Sales Data Analyst",
  "Sales Development Executive",
  "Sales Development Intern",
  "Sales Development Lead",
  "Sales Development Manager",
  "Sales Development Representative",
  "Sales Development Representative (SDR)",
  "Sales Manager",
  "Salesforce Administrator",
  "Salesforce Developer",
  "SAP ABAP Developer",
  "SAP FICO Consultant",
  "Scheduling Coordinator (Virtual)",
  "SDET",
  "SDET (Java)",
  "SDET (Python)",
  "SDR",
  "SDR Intern",
  "SDR Manager",
  "Search Engine Marketing Specialist",
  "Security Analyst",
  "Security Engineer",
  "Security Test Engineer",
  "Selenium Automation Engineer",
  "Selenium Tester",
  "SEM Specialist",
  "Senior Account Manager (CS)",
  "Senior Administrative Assistant",
  "Senior AI Developer",
  "Senior AI Engineer",
  "Senior AI Platform Engineer",
  "Senior AI Research Engineer",
  "Senior AI/ML Engineer",
  "Senior Analytics Consultant",
  "Senior Application Developer",
  "Senior Applied Data Scientist",
  "Senior Applied Scientist",
  "Senior Automation Engineer",
  "Senior Automation Tester",
  "Senior Battery Engineer",
  "Senior BDR",
  "Senior BI Analyst",
  "Senior BMS Engineer",
  "Senior Brand Manager",
  "Senior Business Analyst",
  "Senior Business Development Executive",
  "Senior Business Development Representative",
  "Senior Business Intelligence Analyst",
  "Senior CAD Engineer",
  "Senior Client Success Manager",
  "Senior Cloud Engineer",
  "Senior Computer Vision Engineer",
  "Senior Content Marketing Specialist",
  "Senior Content Strategist",
  "Senior Controls Engineer",
  "Senior CSM",
  "Senior Customer Experience Manager",
  "Senior Customer Success Manager",
  "Senior Data Analyst",
  "Senior Data Analyst II",
  "Senior Data Engineer",
  "Senior Data Operations Analyst",
  "Senior Data Quality Analyst",
  "Senior Data Science Manager",
  "Senior Data Scientist",
  "Senior Data Scientist II",
  "Senior Data Specialist",
  "Senior Deep Learning Engineer",
  "Senior DevOps Engineer",
  "Senior DevSecOps Engineer",
  "Senior Digital Marketer",
  "Senior Digital Marketing Executive",
  "Senior Digital Marketing Specialist",
  "Senior Django Developer",
  "Senior Email Marketing Specialist",
  "Senior Embedded Systems Engineer",
  "Senior Energy Analyst",
  "Senior Environmental Analyst",
  "Senior Environmental Engineer",
  "Senior ESG Analyst",
  "Senior EV Design Engineer",
  "Senior EV Engineer",
  "Senior Executive Assistant",
  "Senior Financial Analyst",
  "Senior Flask Developer",
  "Senior Frontend Developer",
  "Senior Frontend Engineer",
  "Senior Full Stack Developer",
  "Senior Full Stack Engineer",
  "Senior GenAI Engineer",
  "Senior Growth Marketer",
  "Senior Implementation Manager",
  "Senior JavaScript Developer",
  "Senior LLM Engineer",
  "Senior Marketing Analyst",
  "Senior Mechanical Design Engineer",
  "Senior MERN Stack Developer",
  "Senior MERN Stack Engineer",
  "Senior MIS Analyst",
  "Senior ML Engineer",
  "Senior MLOps Engineer",
  "Senior NLP Engineer",
  "Senior Node.js Developer",
  "Senior Onboarding Manager",
  "Senior Operations Analyst",
  "Senior Operations Associate",
  "Senior Operations Coordinator",
  "Senior Operations Executive",
  "Senior Operations Manager",
  "Senior Operations Specialist",
  "Senior Performance Marketer",
  "Senior Performance Test Engineer",
  "Senior Platform Engineer",
  "Senior Powertrain Engineer",
  "Senior PPC Specialist",
  "Senior Product Analyst",
  "Senior Product Marketing Manager",
  "Senior Project Coordinator",
  "Senior Project Manager",
  "Senior Project Specialist",
  "Senior Prompt Engineer",
  "Senior Python Developer",
  "Senior Python Engineer",
  "Senior Python Programmer",
  "Senior Python Software Engineer",
  "Senior QA Analyst",
  "Senior QA Automation Engineer",
  "Senior QA Engineer",
  "Senior React Developer",
  "Senior Renewable Energy Engineer",
  "Senior Renewal Manager",
  "Senior Reporting Analyst",
  "Senior Research Analyst",
  "Senior Research Scientist",
  "Senior SDET",
  "Senior SDR",
  "Senior Security Engineer",
  "Senior SEO Analyst",
  "Senior SEO Executive",
  "Senior SEO Specialist",
  "Senior Site Reliability Engineer",
  "Senior Social Media Executive",
  "Senior Social Media Manager",
  "Senior Social Media Strategist",
  "Senior Software Developer",
  "Senior Software Engineer",
  "Senior Software Tester",
  "Senior Solar Engineer",
  "Senior Solar Project Engineer",
  "Senior Sustainability Analyst",
  "Senior Sustainability Specialist",
  "Senior Test Analyst",
  "Senior Test Automation Engineer",
  "Senior Test Engineer",
  "Senior Vehicle Integration Engineer",
  "Senior Virtual Assistant",
  "Senior Web Developer",
  "SEO Analyst",
  "SEO Consultant",
  "SEO Content Specialist",
  "SEO Content Writer",
  "SEO Copywriter",
  "SEO Executive",
  "SEO Executive (Search Engine Optimization)",
  "SEO Expert",
  "SEO Intern",
  "SEO Manager",
  "SEO Specialist",
  "SEO Strategist",
  "ServiceNow Developer",
  "Shopify VA",
  "Site Reliability Engineer",
  "Site Reliability Engineer (SRE)",
  "SOC/SOH Algorithm Engineer",
  "Social Content Manager",
  "Social Media Community Manager",
  "Social Media Content Creator",
  "Social Media Coordinator",
  "Social Media Executive",
  "Social Media Intern",
  "Social Media Lead",
  "Social Media Manager",
  "Social Media Manager (SMM)",
  "Social Media Marketing Manager",
  "Social Media Specialist",
  "Social Media Strategist",
  "Social Media VA",
  "Social Video Producer",
  "Software Architect",
  "Software Developer",
  "Software Development Engineer in Test",
  "Software Engineer",
  "Software Engineer in Test (SET)",
  "Software Engineering Manager",
  "Software Quality Engineer",
  "Software Test Engineer",
  "Software Test Intern",
  "Software Tester",
  "Solar Commissioning Engineer",
  "Solar Design Engineer",
  "Solar Electrical Engineer",
  "Solar Energy Engineer",
  "Solar Engineer",
  "Solar Engineering Intern",
  "Solar Installation Engineer",
  "Solar O&M Engineer",
  "Solar Operations Manager",
  "Solar Project Coordinator",
  "Solar Project Engineer",
  "Solar Project Manager",
  "Solar PV Engineer",
  "Solar Site Engineer",
  "Solar Systems Engineer",
  "Solar Trainee",
  "SolidWorks Engineer",
  "Solutions Architect",
  "Speech Recognition Engineer",
  "SQL Analyst",
  "SQL Developer",
  "Staff AI Engineer",
  "Staff Data Analyst",
  "Staff Data Scientist",
  "Staff EV Engineer",
  "Staff Full Stack Engineer",
  "Staff Machine Learning Engineer",
  "Staff ML Engineer",
  "Staff Python Developer",
  "Staff QA Engineer",
  "Staff SDET",
  "Staff Software Engineer",
  "Statistical Analyst",
  "Strategic Customer Success Manager",
  "Structural Engineer (Auto)",
  "Supply Chain Analyst",
  "Support Specialist",
  "Sustainability Analyst",
  "Sustainability Consultant",
  "Sustainability Coordinator",
  "Sustainability Data Analyst",
  "Sustainability Intern",
  "Sustainability Manager",
  "Sustainability Program Associate",
  "Sustainability Program Manager",
  "Sustainability Specialist",
  "SVP of AI & Data",
  "SVP of Artificial Intelligence",
  "SVP of Client Services",
  "SVP of Customer Success",
  "SVP of Data & Analytics",
  "SVP of Data Science",
  "SVP of Engineering",
  "SVP of Marketing",
  "SVP of Operations",
  "SVP of Quality",
  "SVP of Sustainability",
  "Systems Integration Engineer (EV)",
  "Tableau Developer",
  "Talent Acquisition Specialist",
  "Team Lead - Customer Success",
  "Tech Virtual Assistant",
  "Technical Architect",
  "Technical CSM",
  "Technical Customer Success Manager",
  "Technical Product Manager",
  "Technical SEO Specialist",
  "Technical Support Engineer (L1)",
  "Technical Support Representative",
  "Technical Writer",
  "Telehealth Coordinator",
  "Telesales Executive",
  "Test Analyst",
  "Test Architect",
  "Test Automation Analyst",
  "Test Automation Developer",
  "Test Automation Engineer",
  "Test Automation Lead",
  "Test Consultant",
  "Test Developer",
  "Test Lead",
  "Test Manager",
  "Test Technician",
  "Testing Manager",
  "Thermal Engineer (EV)",
  "Thermal Management Engineer",
  "Tooling Design Engineer",
  "Traction Motor Engineer",
  "Trainee Full Stack Developer",
  "Travel Virtual Assistant",
  "Treasury Analyst",
  "TypeScript Developer",
  "UAT Tester",
  "UI Developer",
  "UI Engineer",
  "UI/UX Developer",
  "Unreal Engine Developer",
  "US IT Recruiter (Night Shift)",
  "User Acceptance Tester",
  "User Acquisition Specialist",
  "VA Team Manager",
  "Vehicle Controls Engineer",
  "Vehicle Design Engineer",
  "Vehicle Dynamics Engineer",
  "Vehicle Integration Engineer",
  "Vehicle Test Engineer",
  "Virtual Administrative Assistant",
  "Virtual Assistant",
  "Virtual Assistant Intern",
  "Virtual Assistant Team Lead",
  "Virtual Bookkeeping Assistant",
  "Virtual Chief of Staff",
  "Virtual Clerk",
  "Virtual Legal Assistant",
  "Virtual Marketing Assistant",
  "Virtual Office Assistant",
  "Virtual Operations Assistant",
  "Virtual Operations Manager",
  "Virtual Personal Assistant",
  "Virtual Program Coordinator",
  "Virtual Project Coordinator",
  "Virtual Project Manager",
  "Virtual Receptionist",
  "Virtual Research Assistant",
  "Virtual Social Media Assistant",
  "Virtual Support Associate",
  "VP - AI",
  "VP - AI & Machine Learning",
  "VP - AI Engineering",
  "VP - AI Research",
  "VP - Analytics",
  "VP - Battery Technology",
  "VP - Brand Marketing",
  "VP - Business Development",
  "VP - Business Operations",
  "VP - Client Services",
  "VP - Customer Experience",
  "VP - Customer Success",
  "VP - Data",
  "VP - Data & Analytics",
  "VP - Data Analytics",
  "VP - Data Science",
  "VP - Data Science & Analytics",
  "VP - Data Science & Machine Learning",
  "VP - Demand Generation",
  "VP - Digital Marketing",
  "VP - Energy",
  "VP - Engineering",
  "VP - Engineering (EV)",
  "VP - Environmental Affairs",
  "VP - ESG",
  "VP - Executive Operations",
  "VP - Growth",
  "VP - Growth Marketing",
  "VP - Machine Learning",
  "VP - Marketing",
  "VP - Marketing Operations",
  "VP - ML Engineering",
  "VP - Operations",
  "VP - Powertrain Engineering",
  "VP - Product Engineering",
  "VP - Product Marketing",
  "VP - Quality Assurance",
  "VP - Quality Engineering",
  "VP - R&D (EV)",
  "VP - Renewable Energy",
  "VP - Research & Development",
  "VP - Sales",
  "VP - Sales Development",
  "VP - Software Engineering",
  "VP - Software Quality",
  "VP - Strategic Partnerships",
  "VP - Sustainability",
  "VP - Technology",
  "VP - Testing",
  "VP - Vehicle Engineering",
  "VP - Virtual Support",
  "VP Engineering",
  "VP of Administrative Services",
  "VP of AI",
  "VP of Business Intelligence",
  "VP of QA",
  "Vue.js Developer",
  "Waste Management Analyst",
  "Web Analyst",
  "Web Application Developer",
  "Web Architect",
  "Web Developer",
  "Web Development Intern",
  "Web Development Manager",
  "Web Engineer",
  "Web QA Engineer",
  "Wind Energy Engineer",
  "Workday Consultant",
  "Workflow Analyst",
  "Zoho Developer"
];

export default ALL_ROLES;
